// PetMoon brand configuration.
// TODO: replace with the real WhatsApp Business number (country code + number,
// digits only, e.g. "5215512345678" for México).
export const WHATSAPP_NUMBER = "523313450460";

export type MetodoPago = "efectivo" | "transferencia" | "tarjeta";

export const METODO_PAGO_LABEL: Record<MetodoPago, string> = {
  efectivo: "Pago en efectivo / terminal al abordar",
  transferencia: "Transferencia SPEI / Mercado Pago",
  tarjeta: "Tarjeta de crédito o débito",
};

/** Mensaje de agradecimiento tras registrar la solicitud. */
export const MENSAJE_GRACIAS =
  "Gracias por registrar tu ruta. Tu mascota está segura 🐾";

export interface BookingData {
  origen: string;
  origenReferencias: string;
  destino: string;
  destinoReferencias: string;
  idaYVuelta: boolean;
  tipoMascota: string;
  nombreMascota: string;
  tamano: string;
  notas: string;
  fecha: string;
  hora: string;
  duenoViaja: "" | "si" | "no";
  contactoDestino: string;
  clienteNombre: string;
  clienteTelefono: string;
  metodoPago: MetodoPago;
}

const METODO_PAGO_CORTO: Record<MetodoPago, string> = {
  efectivo: "Efectivo / Terminal al abordar",
  transferencia: "Transferencia SPEI / Mercado Pago",
  tarjeta: "Tarjeta de crédito o débito",
};

export interface QuoteLine {
  distanciaKm: number;
  duracionMin: number;
  precioMxn: number;
}

function fmtFechaHora(d: BookingData): string {
  return [d.fecha, d.hora].filter(Boolean).join(" · ");
}

export function buildWhatsAppMessage(d: BookingData, q: QuoteLine | null = null): string {
  const lines = [
    "🐾 *NUEVA SOLICITUD DE VIAJE - PETMOON*",
    "",
    `👤 *Cliente:* ${d.clienteNombre.trim() || "—"}`,
    `📱 *Teléfono:* ${d.clienteTelefono.trim() || "—"}`,
    `🐶 *Mascota:* ${d.tipoMascota || "—"} ${d.nombreMascota.trim()} · tamaño ${d.tamano || "—"}`.replace(
      /\s+/g,
      " ",
    ),
    `📍 *Origen:* ${d.origen.trim()}`,
    ...(d.origenReferencias.trim() ? [`   ↳ *Referencias:* ${d.origenReferencias.trim()}`] : []),
    `🏁 *Destino:* ${d.destino.trim()}`,
    ...(d.destinoReferencias.trim() ? [`   ↳ *Referencias:* ${d.destinoReferencias.trim()}`] : []),
    `📏 *Distancia:* ${q ? `${q.distanciaKm} km` : "por confirmar"}`,
    `💰 *Total a Cobrar:* ${q ? `$${Math.round(q.precioMxn).toLocaleString("es-MX")} MXN` : "por confirmar"}`,
    `💳 *Método de Pago:* ${METODO_PAGO_CORTO[d.metodoPago]}`,
    `📅 *Fecha y Hora:* ${fmtFechaHora(d)}`,
    `🔄 *Tipo de Viaje:* ${d.idaYVuelta ? "Ida y Vuelta" : "Solo Ida"}`,
    `👤 *Acompañante:* ${d.duenoViaja === "si" ? "Con Dueño" : "Solo Mascota"}`,
    `📩 *Contacto en Destino:* ${d.duenoViaja === "no" && d.contactoDestino.trim() ? d.contactoDestino.trim() : "N/A"}`,
  ];
  if (d.notas.trim()) lines.push(`📝 *Notas:* ${d.notas.trim()}`);
  return lines.join("\n");
}

export function buildWhatsAppUrl(d: BookingData): string {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(buildWhatsAppMessage(d))}`;
}

export function buildWhatsAppUrlWithQuote(d: BookingData, q: QuoteLine | null): string {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(buildWhatsAppMessage(d, q))}`;
}


/** Datos bancarios para pago por transferencia SPEI.
 *  Deja los campos vacíos si aún no quieres mostrarlos. */
export const SPEI = {
  banco: "",
  beneficiario: "PetMoon",
  clabe: "",
} as const;

export function speiConfigurado(): boolean {
  return SPEI.banco.trim().length > 0 && SPEI.clabe.replace(/\D/g, "").length === 18;
}

export function conceptoPago(clienteNombre: string): string {
  return `Viaje PetMoon - ${clienteNombre.trim() || "Cliente"}`;
}
